"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logos = void 0;
var cr_logo_light_png_1 = __importDefault(require("./app/assets/creative_rides/cr_logo_light.png"));
var cr_logo_dark_png_1 = __importDefault(require("./app/assets/creative_rides/cr_logo_dark.png"));
exports.logos = {
    dark: {
        img: cr_logo_light_png_1.default,
        background: "bg-[#1A1A1A]",
    },
    light: {
        img: cr_logo_dark_png_1.default,
        background: "bg-transparent",
    },
};
